import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Headphones } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export default function WeeklyCard({ issue, headline, ctaLabel = "Read & listen" }) {
  const [m, setM] = useState(issue);
  useEffect(() => {
    if (issue === undefined) api.get("/weekly/latest").then((r) => setM(r.data)).catch(() => setM(null));
  }, [issue]);
  if (!m) return null;
  const first = m.body.split("\n\n")[0];
  return (
    <div className="relative overflow-hidden rounded-[32px] border border-bt-border bg-bt-surface p-7 sm:p-10" data-testid="weekly-card">
      <svg viewBox="0 0 200 100" className="pointer-events-none absolute -right-16 -top-10 h-48 w-96 text-bt-sage" fill="none">
        <path d="M100 50c-18-26-38-38-58-38C20 12 6 30 6 50s14 38 36 38c20 0 40-12 58-38zm0 0c18 26 38 38 58 38 22 0 36-18 36-38s-14-38-36-38c-20 0-40 12-58 38z" stroke="currentColor" strokeWidth="6" />
      </svg>
      <div className="relative">
        <p className="eyebrow mb-3">{headline || (m.kind === "affirmation" ? "This month's affirmation" : "This week's message")}{m.theme && m.kind !== "affirmation" ? ` · ${m.theme}` : ""}</p>
        <h3 className="text-2xl leading-snug sm:text-3xl" data-testid="weekly-card-subject">{m.subject}</h3>
        <p className="mt-4 line-clamp-3 whitespace-pre-line text-base md:text-lg">{first}</p>
        {m.audio_url && (
          <div className="mt-5 flex items-center gap-3 rounded-2xl bg-bt-sage p-3" data-testid="weekly-card-audio">
            <Headphones size={18} className="shrink-0 text-bt-primary" />
            <audio src={mediaUrl(m.audio_url)} controls className="h-10 w-full" />
          </div>
        )}
        <Link to="/weekly" className="btn-ghost -ml-4 mt-4" data-testid="weekly-card-link">{ctaLabel} <ArrowRight size={16} /></Link>
      </div>
    </div>
  );
}
